import { mandantSettings } from '../../../Settings/mandants/mandant-settings';
import { Mandant, MandantSettings, UserRole } from '../../../util/types';
import { MenuItem } from 'primereact/menuitem';
import { userRoles } from '../../../Settings/data';
import { StateContextType } from '../../../util/providers/StateProvider';
import { getMandantSettingsByMandant } from '../../../util/mandant-settings-utils';
import getLogger, { Logger } from '../../../log';
import { AuthContextType } from '../../../Auth/utils/interfaces';

const logger: Logger = getLogger('Debug menu');

const DemouserMenu: (context: AuthContextType) => MenuItem[] = (context: AuthContextType): MenuItem[] => {
  logger.debug('DemouserMenu');
  const {actions, session} = context;
  const mandants: Mandant[] = mandantSettings.map((mandantSetting: MandantSettings): Mandant => mandantSetting.mandant);
  return [{
    label: `User: ${session?.user_displayname?.toUpperCase() ?? 'GUEST'}`,
    items: mandants.map((mandant: Mandant): MenuItem[] =>
      userRoles.map((userRole: UserRole): MenuItem => (
        {
          label: `${mandant} ${userRole.replace('ROLE_', '')}`.toUpperCase(),
          command: (): Promise<void> => actions.demologin.then(login => login(
            [userRole],
            mandant.toUpperCase(),
            userRole.replace('ROLE_', '').toUpperCase(),
            `${userRole.replace('ROLE_', '')}@${mandant}.test`.toLowerCase(),
          )),
        }
      )),
    ).flat(),
  }];
};

const ThemeMenu: (context: StateContextType) => MenuItem = (context: StateContextType): MenuItem => {
  const {theme, setTheme} = context;
  const mandants: Mandant[] = mandantSettings.map((mandantSetting: MandantSettings): Mandant => mandantSetting.mandant);
  return {
    label: `Theme: ${theme}`,
    items: mandants.map((mandant: Mandant): MenuItem => ({
      label: mandant,
      command: (): void => setTheme(mandant),
    })),
  };
};

const OriginMenu: (context: StateContextType) => MenuItem = (context: StateContextType): MenuItem => {
  const {originMandantSettings, setOriginMandantSettings} = context;
  const mandants: Mandant[] = mandantSettings.map((mandantSetting: MandantSettings): Mandant => mandantSetting.mandant);
  return {
    label: `Domain: ${originMandantSettings.mandant}`,
    items: mandants.map((mandant: Mandant): MenuItem => ({
      label: mandant,
      command: (): void => setOriginMandantSettings(getMandantSettingsByMandant(mandant)),
    })),
  };
};

export const getDebugMenu = (stateContextType: StateContextType, authContextType: AuthContextType): MenuItem[] => {
  logger.debug('Load debug menu');
  return [
    OriginMenu(stateContextType),
    ThemeMenu(stateContextType),
    ...process.env.REACT_APP_DEMO_LOGIN_ENABLED === 'true' ? DemouserMenu(authContextType) : [],
  ];
};

export default getDebugMenu;
